<template>
  <van-button
    v-bind="$attrs"
    :type="tone === 'primary' ? 'info' : 'default'"
    class="publish-button"
    :class="[
      `publish-button--${tone}`,
      `publish-button--${layout}`,
      { 'publish-button--custom-text-color': textColor },
    ]"
    :style="buttonStyle"
    v-on="$listeners"
  >
    <slot />
  </van-button>
</template>

<script>
export default {
  name: "PublishButton",
  inheritAttrs: false,
  props: {
    tone: {
      type: String,
      default: "secondary",
      validator: (value) =>
        ["primary", "secondary", "text", "danger"].includes(value),
    },
    textColor: {
      type: String,
      default: "",
    },
    layout: {
      type: String,
      default: "default",
      validator: (value) =>
        [
          "default",
          "action-bar",
          "action-bar-compact",
          "action-bar-split",
        ].includes(value),
    },
  },
  computed: {
    buttonStyle() {
      return this.textColor
        ? { "--publish-button-text-color": this.textColor }
        : null;
    },
  },
};
</script>

<style lang="less" scoped>
@import "./tokens.less";

.publish-button {
  height: 40px;
  color: @publish-text-regular;
  font-size: 14px;
  font-weight: 400;
  background: @publish-surface;
  border-color: @publish-border;
  border-radius: @publish-radius-control;
  box-shadow: none;
}

.publish-button--primary {
  height: 44px;
  color: #fff;
  font-size: 15px;
  font-weight: 500;
  background: @publish-brand;
  border-color: @publish-brand;
  border-radius: 8px;
}

.publish-button--text {
  height: 32px;
  padding: 0 8px;
  color: @publish-text-secondary;
  background: transparent;
  border: 0;
}

.publish-button--danger {
  color: @publish-danger;
  background: @publish-surface;
  border-color: #ffd7d7;
}

.publish-button.publish-button--action-bar,
.publish-button.publish-button--action-bar-compact,
.publish-button.publish-button--action-bar-split {
  width: 100%;
  height: 47px;
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  border-radius: 10px;
}

.publish-button.publish-button--action-bar-compact {
  padding-right: 8px;
  padding-left: 8px;
  font-size: 14px;
}

.publish-button.publish-button--action-bar-split {
  height: 45px;
  padding-right: 8px;
  padding-left: 8px;
  font-size: 14px;
  border: 0;
  border-radius: 10px;

  &.publish-button--secondary {
    color: @publish-brand;
    background: @publish-surface;
  }
}

.publish-button--custom-text-color {
  color: var(--publish-button-text-color) !important;

  /deep/ .van-button__text,
  /deep/ .van-icon {
    color: inherit !important;
  }
}

</style>
